import React from "react";
import Modal from "../../../components/Reusable/Modal";
import { SupportItem } from "../../../features/auth/store/types/support-types";

interface ViewSupportModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: SupportItem | null;
}

const ViewSupportModal: React.FC<ViewSupportModalProps> = ({
  isOpen,
  onClose,
  item,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="w-full max-w-2xl">
      <h2 className="text-xl font-bold mb-6">Support Item</h2>

      <div className="space-y-4">
        <div>
          <p className="text-xs font-semibold uppercase text-gray-400 dark:text-gray-500 mb-1">
            Question
          </p>
          <p className="text-sm text-gray-800 dark:text-white font-medium">
            {item?.question}
          </p>
        </div>

        <div className="border-t border-[#D0D5DD] dark:border-[#FFFFFF1A]" />

        <div>
          <p className="text-xs font-semibold uppercase text-gray-400 dark:text-gray-500 mb-2">
            Answer
          </p>
          <div
            className="text-sm text-gray-700 dark:text-gray-300 prose prose-sm max-w-none dark:prose-invert [&_a]:text-blue-600 dark:[&_a]:text-blue-400 [&_a]:no-underline hover:[&_a]:text-blue-700 dark:hover:[&_a]:text-blue-300"
            dangerouslySetInnerHTML={{ __html: item?.answer ?? "" }}
          />
        </div>
      </div>

      <div className="flex justify-end mt-6">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 border border-[#D0D5DD] dark:border-[#FFFFFF1A] rounded-lg text-sm font-medium dark:text-white"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default ViewSupportModal;
